import CockpitNotificationStateLookupListResultModelBase from '../_generated/modelBases/cockpit-notification-state-lookup-list-result-model-base';

export default class CockpitNotificationStateLookupListResultModel extends CockpitNotificationStateLookupListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
